export const JOBS_API_ID         = 'JOBS_API_ID';
export const DEVICES_API_ID      = 'BazookaFarmstarDevicesAPI';
export const FEEDBACK_API_ID     = 'BazookaFarmstarFeedbackAPI';
export const USERS_API_ID        = 'BazookaFarmstarUsersAPI';
export const GROUPS_API_ID       = 'BazookaFarmstarGroupsAPI';
export const CREW_MEMBERS_API_ID = 'BazookaFarmstarCrewMembersAPI';
export const SITE_MAP_API_ID = 'BazookaFarmstarSiteMapAPI';
